export const POWER_POLE_SUPPLY_HALF_WIDTH = {
	'big-electric-pole': 2,
	'medium-electric-pole': 3.5,
	'small-electric-pole': 2.5,
	substation: 9,
} as const satisfies Record<string, number>;

export const POWERED_ENTITY_NAMES = {
	accumulator: true,
	'agricultural-tower': true,
	'arithmetic-combinator': true,
	'assembling-machine-1': true,
	'assembling-machine-2': true,
	'assembling-machine-3': true,
	beacon: true,
	'big-mining-drill': true,
	biolab: true,
	'bulk-inserter': true,
	centrifuge: true,
	'chemical-plant': true,
	'cryogenic-plant': true,
	'decider-combinator': true,
	'electric-furnace': true,
	'electric-mining-drill': true,
	'electromagnetic-plant': true,
	'fast-inserter': true,
	'filter-inserter': true,
	foundry: true,
	inserter: true,
	lab: true,
	'laser-turret': true,
	'long-handed-inserter': true,
	'programmable-speaker': true,
	pump: true,
	pumpjack: true,
	radar: true,
	recycler: true,
	roboport: true,
	'selector-combinator': true,
	'small-lamp': true,
	'rocket-silo': true,
	'solar-panel': true,
	'stack-filter-inserter': true,
	'stack-inserter': true,
	'tesla-turret': true,
} as const satisfies Record<string, boolean>;
